var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 14
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M15.3 0A2.7 2.7 0 0 1 18 2.7v8.6a2.7 2.7 0 0 1-2.7 2.7H2.7A2.7 2.7 0 0 1 0 11.3V2.7A2.7 2.7 0 0 1 2.7 0Zm.7 6H2v5.3a.7.7 0 0 0 .7.7h12.6a.7.7 0 0 0 .7-.7zM6.5 9a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm5 0a.5.5 0 1 1 0 1h-3a.5.5 0 0 1 0-1zm3.8-7H2.7a.7.7 0 0 0-.7.7V4h14V2.7a.7.7 0 0 0-.7-.7"
})));
export default SvgIconCard;